(() => {
  function init(root = document) {
    root.querySelectorAll('[data-campaign-film]').forEach(film => {
      if (film.dataset.campaignReady) return;
      film.dataset.campaignReady = 'true';
      film.querySelectorAll('[data-campaign-select]').forEach(button => button.addEventListener('click', () => {
        const version = button.dataset.campaignSelect;
        film.dataset.execution = version;
        film.querySelectorAll('video').forEach(video => { video.hidden = video.dataset.execution !== version; });
        film.querySelectorAll('[data-campaign-select]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        film.querySelector('[data-campaign-name]').textContent = version === 'v1' ? 'FACTORY WIDTH.' : 'WIDE PRESENCE.';
        film.querySelector('[data-campaign-version]').textContent = version.toUpperCase();
        const link = film.querySelector('[data-campaign-link]');
        const previewPrefix = location.pathname.match(/^\/(studio-preview|curated-preview)\//)?.[0].slice(0,-1) || '';
        link.href = previewPrefix + '/products/audi-q3-sportback-f3-' + (version === 'v1' ? 'v1-carbon-frp-body-kit' : 'v2-widebody-carbon-frp-body-kit');
        film.dispatchEvent(new Event('campaign:change'));
      }));
    });
    root.querySelectorAll('[data-campaign-archive]').forEach(archive => {
      if (archive.dataset.ready) return;
      archive.dataset.ready = 'true';
      const form = archive.querySelector('form');
      const groups = [...archive.querySelectorAll('.dz-series')];
      form.hidden = false;
      for (const [field,key] of [['execution','execution'],['color','color'],['scene','scene']]) {
        [...form.elements[field].options].forEach(option => { if (option.value !== 'all' && !groups.some(g => g.dataset[key] === option.value)) option.remove(); });
      }
      const filter = () => {
        let count = 0;
        groups.forEach(group => {
          group.hidden = ['execution','color','scene'].some(key => form.elements[key].value !== 'all' && form.elements[key].value !== group.dataset[key]);
          if (!group.hidden) count += Number(group.dataset.count);
          else group.open = false;
        });
        archive.querySelector('[data-archive-count]').textContent = `${count} images`;
        archive.querySelector('[data-archive-empty]').hidden = count !== 0;
      };
      form.addEventListener('change',filter);
      form.addEventListener('submit',event => event.preventDefault());
      filter();
      const dialog = document.createElement('dialog');
      dialog.className = 'dz-archive-dialog';
      dialog.setAttribute('aria-label','Design render viewer');
      dialog.innerHTML = '<button type="button" data-close aria-label="Close image" title="Close image">&#215;</button><button type="button" data-prev aria-label="Previous image" title="Previous image">&#8592;</button><img alt=""><button type="button" data-next aria-label="Next image" title="Next image">&#8594;</button><p aria-live="polite"></p>';
      archive.append(dialog);
      let items = [], position = 0, trigger;
      const show = () => {
        const selected = items[position];
        dialog.querySelector('img').src = selected.href;
        dialog.querySelector('img').alt = selected.querySelector('img').alt;
        dialog.querySelector('p').textContent = `${position + 1} / ${items.length}`;
      };
      archive.querySelectorAll('[data-archive-image]').forEach(link => link.addEventListener('click',event => {
        event.preventDefault();
        trigger = link;
        items = [...link.closest('.dz-series').querySelectorAll('[data-archive-image]')];
        position = items.indexOf(link);
        show(); dialog.showModal();
        document.documentElement.classList.add('dz-viewer-open');
      }));
      dialog.querySelector('[data-close]').addEventListener('click',() => dialog.close());
      const move = direction => { position = (position + direction + items.length) % items.length; show(); };
      dialog.querySelector('[data-prev]').addEventListener('click',() => move(-1));
      dialog.querySelector('[data-next]').addEventListener('click',() => move(1));
      dialog.addEventListener('keydown',event => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); } });
      dialog.addEventListener('close',() => { document.documentElement.classList.remove('dz-viewer-open'); trigger?.focus(); });
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded',() => init()) : init();
  document.addEventListener('shopify:section:load',event => init(event.target));
})();
